import { thunkProgress } from 'redux-progress';
import fetchCountries from 'api/data/fetchCountries';

export const FETCH_ALL = 'data/countries/FETCH_ALL';
export const fetchAll = () => thunkProgress(FETCH_ALL, fetchCountries());
